/*global jQuery */
let navBurger = (function ($, window, document, undefined) {
  'use strict';

  let $window = $(window),
    $document = $(document),
    $docElement = $(document.documentElement),
    $sectionMain = $('.SectionMain'),
    $sectionFooter = $('.SectionFooter'),
    $navBurger = $('.js-navBurger'),
    $focusableSelectors = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])',

    setInert = function($container, isInert) {
      const $focusables = $container.find($focusableSelectors);
      if (isInert) {
        $focusables.each(function () {
          const $el = $(this);
          $el.data('old-tabindex', $el.attr('tabindex'));
          $el.attr('tabindex', -1);
          $el.attr('aria-hidden', 'true');
        });
      } else {
        $focusables.each(function () {
          const $el = $(this);
          const oldTabindex = $el.data('old-tabindex');
          if (oldTabindex !== undefined) {
            $el.attr('tabindex', oldTabindex);
            $el.removeData('old-tabindex');
          } else {
            $el.removeAttr('tabindex');
          }
          $el.removeAttr('aria-hidden');
        });
      }
    },

    toggleOpenClose = function () {
      if ($docElement.hasClass('NavMain--is-open')) {
        $docElement.removeClass('NavMain--is-open');
        $docElement.removeClass('NavBurger--is-open');
        $navBurger.removeClass('is-open');
        $navBurger.attr('aria-label', 'Hauptmenü öffnen');
        setInert($sectionMain, false);
        setInert($sectionFooter, false);
        setInert($navBurger, true);
      } else {
        $docElement.addClass('NavMain--is-open');
        $docElement.addClass('NavBurger--is-open');
        $navBurger.addClass('is-open');
        $navBurger.attr('aria-label', 'Hauptmenü schließen');
        setInert($sectionMain, true);
        setInert($sectionFooter, true);
        setInert($navBurger, false);
        $('html, body').animate({
          scrollTop: 0
        }, 1);
      }
    },

    init = function () {
      $navBurger.bind('navBurgerState change', function () {
        $navBurger.on('click', function (e) {
          e.preventDefault();
          toggleOpenClose();
        });
      }).trigger('navBurgerState');

      $window.on('resize', function () {
        if ($window.width() < 1248) {
          $docElement.removeClass('NavMain--is-open');
          $docElement.removeClass('NavBurger--is-open');
          $navBurger.removeClass('is-open');
          $navBurger.attr('aria-label', 'Hauptmenü öffnen');
          $navBurger.attr('aria-expanded', 'false');
        } else {
          setInert($sectionMain, false);
          setInert($sectionFooter, false);
          setInert($navBurger, true);
        }
      });
    };



  init();

  return {};

}(jQuery, window, document));
